// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__27wWY","log":"ModalInventoryLogs_log__280O9","date":"ModalInventoryLogs_date__3mycb","userName":"ModalInventoryLogs_userName__2CVIc"};